var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTatLogoWhiteColor256(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.016 154.222V99.719H8.6v-9.704H40.23v9.704h-9.25v54.503H18.017zM226.614 154.222V99.719H217.2v-9.704h31.629v9.704h-9.415v54.503h-12.8zM105.716 69.783l13.956-64.206h11.48l13.831 64.165H132.06l-2.642-13.709h-8.258l-2.478 13.709h-12.965v.041zm16.269-21.719h6.647L125.37 24.24l-3.385 23.824zM.844 246.925L246.884.885l7.387 7.387-246.04 246.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.844 8.23L8.23.845l246.04 246.04-7.387 7.387z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39C12",
    d: "M80.281 221.03v-6.277l21.802-13.502 3.881 6.111-18.044 10.53 18.044 10.28-4.129 6.36zM118.31 241.592l-6.896-3.18 23.37-48.515 6.896 3.179zM172.73 214.712v6.359l-21.677 13.42-4.129-6.07 18.044-10.57-18.044-10.24 4.129-6.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTatLogoWhiteColor256);
export default __webpack_public_path__ + "static/media/tat-logo-white-color-256.5e4e2c3611dfc0d66c0ab0f1db7e466d.svg";
export { ForwardRef as ReactComponent };